import axios from 'axios'
import {CookiesService} from './Cookie.service'
/**
 * Instância axios do módulo Levantamento de Mercado (levantamento-service, FastAPI).
 *
 * baseURL = VITE_LEVANTAMENTO_URL — deve conter o prefixo completo da API.
 * Valor local: http://localhost:8084/api/levantamento/v1
 *
 * Mesmo padrão do axiosInstanceCarona: em dev o levantamento-service aceita
 * requisições com bypass (DEV_AUTH_KEY); em produção valida o JWT do core
 * (JWT_SECRET compartilhado, claim modules). Anexamos o Bearer do cookie do
 * core para exercitar a auth real quando disponível.
 */
const MyAxiosInstanceLevantamento = axios.create({
    baseURL: import.meta.env.VITE_LEVANTAMENTO_URL,
})

const cookies = new CookiesService()

MyAxiosInstanceLevantamento.interceptors.request.use(
    (config) => {
        let auth = cookies.getAuthData()
        config.headers.Authorization = `Bearer ${auth?.access_token}`
        return config
    },
    (error) => Promise.reject(error)
)

export default MyAxiosInstanceLevantamento
